var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button green px-8px",on:{"click":_vm.validateSheet}},[_c('span',{staticClass:"material-icons valign-middle text-23px"},[_vm._v("rule")])])}
var staticRenderFns = []

export { render, staticRenderFns }